export enum FichaListaSortStatusEnum {
  UNSORT = 0,
  ASC = 1,
  DESC = 2,
}
